<template>
    <div>
        <el-dialog :title="dataActionBox.boxTitle" :visible.sync="dataActionBox.showStatus" append-to-body top="2rem"
            width="80%" center :before-close="initActionBox">
            <el-form :model="sendDataInfo" v-if="formData" inline label-width="120px" size="mini" ref="sendDataInfo"
                :show-message="false">
                <el-row>
                    <el-col :span="formOneValue.entityField == 'uploadVoList' ? 24 : 12"
                        v-for="(formOneValue, formOneKey) in formData.jurconfigform" :key="formOneKey">
                        <el-form-item v-if="formOneValue.isShow == 1" :label="formOneValue.showField"
                            :prop="formOneValue.entityField"
                            :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'], },] : []">
                            <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>

                            <!-- 系统字段 -->
                            <div v-if="formOneValue.isReserved == 0">
                                <!-- <el-date-picker v-if="formOneValue.entityField == 'cliTervalidity'" style="width: 100%;" v-model="sendDataInfo[formOneValue.entityField]"  type="date" placeholder="选择日期"  format="yyyy 年 MM 月 dd 日" value-format="timestamp"></el-date-picker> -->
                                <!-- <el-date-picker v-else-if="formOneValue.entityField == 'cliRedate'" style="width: 100%;" v-model="sendDataInfo[formOneValue.entityField]"  type="date" placeholder="选择日期"  format="yyyy 年 MM 月 dd 日" value-format="timestamp"></el-date-picker> -->

                                <df-date :isType="true" :isShowLong="false" :isdisabled="formOneValue.isChange == 0"
                                    v-if="formOneValue.entityField == 'cliRedate'"
                                    v-model="sendDataInfo[formOneValue.entityField]" />
                                <df-date :isType="true" :isdisabled="formOneValue.isChange == 0"
                                    v-else-if="formOneValue.fieldType == 'date'"
                                    v-model="sendDataInfo[formOneValue.entityField]" />
                                <div v-else-if="formOneValue.entityField == 'uploadVoList'">
                                    <el-upload class="upload-demo" :action="requesUrl + '/upload/fileupload'"
                                        :headers="token" :multiple="true" :on-success="fileUpload"
                                        :before-remove="beforeRemove" :before-upload="beforeUpload" :file-list="fileList"
                                        list-type="picture">
                                        <el-button size="small" type="primary">点击上传</el-button>
                                        <!-- <div slot="tip" class="el-upload__tip">不超过500kb</div> -->
                                        <el-button @click.stop="openFile1()" type="primary" icon="el-icon-upload"
                                            size="mini">高拍仪上传</el-button>
                                    </el-upload>
                                </div>
                                <!-- 证照类型 -->
                                <el-select v-else-if="formOneValue.entityField == 'lityId'"
                                    v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择"
                                    :disabled="formOneValue.isChange == 0" clearable @change="lityChange">
                                    <el-option v-for="item in LicensetypeList" :key="item.lityId" :label="item.lityName"
                                        :value="item.lityId"></el-option>
                                </el-select>
                                <!-- 是否拦截 -->
                                <el-radio-group v-else-if="formOneValue.entityField == 'isIntercept'"
                                    :disabled="formOneValue.isChange == 0" v-model="sendDataInfo[formOneValue.entityField]">
                                    <el-radio-button label="0">否</el-radio-button>
                                    <el-radio-button label="1">是</el-radio-button>
                                </el-radio-group>
                                <!-- 备注 -->
                                <el-input v-else-if="formOneValue.entityField == 'remark'" type="textarea"
                                    v-model.trim="sendDataInfo[formOneValue.entityField]" maxlength="200"></el-input>
                                    <el-input v-else-if="formOneValue.entityField =='cliTernumber'" v-model.trim="sendDataInfo[formOneValue.entityField]"
                                    :maxlength="$store.state.inputLength" clearable>
                                    <template slot="append"><span style="color: red;">{{sendDataInfo[formOneValue.entityField] == '' || sendDataInfo[formOneValue.entityField] == null || sendDataInfo[formOneValue.entityField] == undefined ? 0 : sendDataInfo[formOneValue.entityField].length }}位</span></template>
                                </el-input>
                                <el-input v-else :id="formOneValue.entityField"
                                    v-model="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength"
                                    clearable></el-input>


                            </div>
                            <!-- 扩展字段 -->
                            <div v-if="formOneValue.isReserved == 1">

                                <!-- 自填 -->
                                <el-input v-model.trim="sendDataInfo[formOneValue.entityField]"
                                    v-if="formOneValue.operatType == 0" :maxlength="$store.state.inputLength"
                                    clearable></el-input>
                                <!-- 选择数据来源 -->
                                <el-input v-model.trim="sendDataInfo[formOneValue.entityField]" v-else
                                    :maxlength="$store.state.inputLength" clearable></el-input>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>


            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="initActionBox">取 消</el-button>
                <el-button type="primary" @click="sendDataAction('sendDataInfo')">确 定</el-button>
            </div>
        </el-dialog>
        <FileNewAction ref="FileNewAction" v-if="showFile" @isshowFile="IsshowFile" :showFile="showFile"
            @NewelectFileIds="changeInputModel"></FileNewAction>

    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
export default {
    name: 'customerCertificates',

    // props:['formData'],
    //import引入的组件需要注入到对象中才能使用
    components: {

    },
    data() {
        //这里存放数据
        return {
            token: { token: sessionStorage.getItem('token') },
            dataActionBox: {
                showStatus: false,
                openMode: 'ltr' || 'rtl',
                boxTitle: '新增' || '编辑',
                actionType: 0, // 0新增，1修改
            },
            sendDataInfo: {
                lityId: "",	//证照类型
                lityName: "",
                isIntercept: 1,	//是否拦截
                cmModifier: "",//修改人
                "cliCreater": 0,
                "cliRedate": 0,
                "cliReoffice": "",
                "cliReserves1": "",
                "cliReserves2": "",
                "cliReserves3": "",
                "cliReserves4": "",
                "cliReserves5": "",
                "cliReserves6": "",
                "cliTername": "",	//证照名称
                "cliTernumber": "",// 证照号
                "cliTervalidity": 0,
                "cmId": 0,
                uploadVoList: [],
                remark: "", //备注
            },
            fileList: [], //文件
            requesUrl: "",
            imgUrl: "",
            formData: {},
            LicensetypeList: [],//证照列表
            dialogGPY: false,
            showFile: false,
            view1_mode_list: [],
            view1_resolution_list: [],
            img_base64List: [],
            view1_mode_selected: '1',
            view1_resolution_selected: '',
            selectFileIds: [],
            // NewelectFileIds: [],
            gpyNum: 0,
            watchZZInfo: false
        };
    },
    //监听属性 类似于data概念
    computed: {
    },
    //监控data中的数据变化
    watch: {
        'sendDataInfo.lityId': {
            handler(newVal) {
                for (let i = 0; i < this.LicensetypeList.length; i++) {
                    const v = this.LicensetypeList[i];
                    if (newVal == v.lityId) {
                        this.sendDataInfo.lityName = v.lityName
                        break
                    }
                }
            },
            deep: true
        },
        "sendDataInfo.cliTervalidity": {
            handler: function (newValue, oldValue) {
                if (this.watchZZInfo) {

                    this.$nextTick(() => {
                        if (newValue == '' || newValue == 0.5) {
                            return
                        }
                        let data = new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1
                        if (newValue <= data) {
                            if (newValue.length < 4) {
                                this.sendDataInfo.cliTervalidity = ''
                            } else {
                                this.$confirm('确定要使用吗？有效期已过！', '警告', {
                                    confirmButtonText: '确定',
                                    cancelButtonText: '取消',
                                    type: 'error'
                                }).then(() => {

                                }).catch(() => {
                                    this.sendDataInfo.cliTervalidity = ''

                                });
                            }

                        }
                        if (newValue > data && (data + 30 * 24 * 60 * 60 * 1000) > newValue) {
                            this.$confirm('确定要使用吗？剩余有效期30天以内！', '提醒', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(() => {

                            }).catch(() => {
                                this.sendDataInfo.cliTervalidity = ''
                            });
                        }
                    })
                } else {
                    this.watchZZInfo = true
                }
            },
            deep: true,
        },
    },
    //方法集合
    methods: {
        IsshowFile(value) {
            this.showFile = value
            console.log(this.showFile)
        },
        changeInputModel(val) {
            if (this.dataActionBox.actionType == 0) {
                this.fileList = []
                val.forEach(item => {
                    console.log(item);
                    this.fileList.push({
                        name: item.fileName,
                        url: this.imgUrl + "/" + item.fileUrl,
                    });
                })
                this.sendDataInfo.uploadVoList = val
                // this.sendDataInfo.uploadVoList=JSON.parse(JSON.stringify(val))
                console.log(this.sendDataInfo.uploadVoList, 'this.sendDataInfo.uploadVoList1')

                console.log(val, this.sendDataInfo.uploadVoList, 'cla')
                // this.$nextTick(e => {

                // 	this.sendDataInfo.uploadVoList.forEach((i, index) => {
                // 		console.log(i);
                // 		this.fileList.push({
                // 			name: i.fileName,
                // 			url: this.imgUrl + "/" + i.fileUrl,
                // 		});
                // 	})
                // })

                console.log(this.fileList);
                this.$forceUpdate()


                this.showFile = false
            } else {
                val.forEach(item => {
                    console.log(item);
                    this.fileList.push({
                        name: item.fileName,
                        url: this.imgUrl + "/" + item.fileUrl,
                    });
                })
                this.sendDataInfo.uploadVoList.push(...val)
                console.log(this.fileList);
                this.$forceUpdate()


                this.showFile = false
            }


        },

        //  打开文件上传组件
        openFile1() {
            this.showFile = true

            // this.$refs["FileNewAction"].openBox()
        },
        //证照选择变化
        lityChange(data) {
            this.sendDataInfo.cliTername = data
            if (this.$parent.sendDataInfo.cmSocialcode != '' && data == '营业执照') {
                this.sendDataInfo.cliTernumber = this.$parent.sendDataInfo.cmSocialcode
            }
        },
        // 新增或修改
        sendDataAction(formName) {
            let flag = false;
            this.$refs[formName].validate((valid) => {
                if (valid) { } else {
                    this.$message({
                        message: "请完善必填信息",
                        type: "error",
                    });
                    flag = true;
                    return false;
                }
            });
            if (flag) return false;
            let sendData = JSON.parse(JSON.stringify(this.sendDataInfo))
            console.log('证', sendData);
            this.$emit("returnlicence", sendData, this.dataActionBox.actionType);
            this.dataActionBox.showStatus = false;
            this.$refs[formName].resetFields();
            this.init();
        },
        async fileUpload(res, file,fileList) {
            if (res.status == 200) {
                this.sendDataInfo.uploadVoList.push(res.result[0])
                this.fileList=fileList
            } else {
                this.fileList=fileList
                this.fileList.forEach((item,index)=>{
                    if (item.response.status==500) {
                        this.fileList.splice(index, 1)
                    }
                })
                return this.$message.error(res.message)
            }

        },
        beforeUpload(file) {
            // console.log(file, this.sendDataInfo.uploadVoList);
            for (let i = 0; i < this.sendDataInfo.uploadVoList.length; i++) {
                const v = this.sendDataInfo.uploadVoList[i]
                if (v.fileName == file.name) {
                    this.$message({
                        type: "error",
                        message: "请勿重复添加",
                    })
                    return false
                }
            }
        },
        beforeRemove(file, fileList) {
            this.fileList=fileList
            let index = 0
            for (let i = 0; i < fileList.length; i++) {
                const item = fileList[i];
                if (item.uid == file.uid) {
                    index = i
                    break
                }
            }
            this.sendDataInfo.uploadVoList.splice(index, 1)
        },
        //获取图片存取的根路径
        imgur() {
            this.requesUrl = this.$store.getters.getConfig.requestUrl;
            this.imgUrl = this.$store.getters.getConfig.imgUrl;
        },
        //取消新增
        initActionBox() {
            this.$confirm("确定取消" + this.dataActionBox.boxTitle + "吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.dataActionBox.showStatus = false;
                    this.$refs["sendDataInfo"].resetFields();
                    this.init();
                })
                .catch(() => { });
        },
        //初始化
        init() {
            for (let key in this.sendDataInfo) {
                this.sendDataInfo[key] = "";
            }
            this.fileList = [];
            this.sendDataInfo.uploadVoList = [];
            this.dataActionBox.actionType = 0;
        },
        //父级传入
        openBox(cate, formData, mainId, oldData = '') {
            this.formData = formData
            this.init()
            this.sendDataInfo.cmId = mainId
            if (cate == 0) {
                this.sendDataInfo.lityId = ""	//证照类型初始值
                this.sendDataInfo.isIntercept = 1	//证照类型初始值
                this.dataActionBox.boxTitle = '新增证照信息'
                this.dataActionBox.openMode = 'ltr'
                this.watchZZInfo = true
            } else {
                this.watchZZInfo = false
                this.dataActionBox.boxTitle = '编辑证照信息'
                this.dataActionBox.openMode = 'rtl'
                for (let key in oldData) {
                    if (key == 'uploadVoList') {
                        oldData[key].forEach((item, index) => {
                            this.fileList.push({
                                name: item.fileName,
                                url: this.imgUrl + '/' + item.fileUrl,
                            })
                        })
                        this.$set(this.sendDataInfo, key, oldData[key])
                    } else {
                        this.$set(this.sendDataInfo, key, oldData[key]);
                    }
                    // this.sendDataInfo[key]  = oldData[key]
                }
            }
            this.dataActionBox.actionType = cate
            this.dataActionBox.showStatus = true

        },


        //查询所有证照类型
        getPartDictionariesData() {
            this.$http.getPartDictionariesData({ ids: [55] }).then((res) => {
                if (res && res.status == 200) {
                    res.result.khzzlx.forEach((v) => {
                        v.lityId = v.diValue
                        this.LicensetypeList.push(v)
                    })
                    // console.log(this.LicensetypeList);
                }
            }).catch(() => {
                this.$message({
                    type: 'error',
                    message: '查询所有证照类型失败'
                });
            })
        },

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getPartDictionariesData()
        this.imgur()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
    beforeCreate() {
    }, //生命周期 - 创建之前
    beforeMount() {
    }, //生命周期 - 挂载之前
    beforeUpdate() {
    }, //生命周期 - 更新之前
    updated() {
    }, //生命周期 - 更新之后
    beforeDestroy() {
    }, //生命周期 - 销毁之前
    destroyed() {
    }, //生命周期 - 销毁完成
    activated() {
    }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style></style>